<div class="modal-editar-contato flex-direction-column">
  <div class="modal-editar-contato-cabecalho flex-direction-row justify-between align-center">
    <span class="modal-editar-contato-titulo">Editar contato</span>
    <button type="button" class="modal-editar-contato-fechar-x" title="Fechar" (click)="cancelar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-editar-contato-linha"></div>

  <form class="modal-editar-contato-corpo" (ngSubmit)="salvar()">
    <app-campo-texto
      label="Nome"
      placeholder="Nome do contato"
      name="nome"
      [(ngModel)]="nome"
      [erro]="erroNome"
      [disabled]="salvando()"
    ></app-campo-texto>
  </form>

  <div class="modal-editar-contato-linha"></div>

  <div class="modal-editar-contato-rodape flex-direction-row justify-end gap-10">
    <button type="button" class="modal-editar-contato-btn-cancelar" (click)="cancelar()">Cancelar</button>
    <app-botao label="Salvar" [icone]="''" largura="auto" [disabled]="salvando()" (aoClicar)="salvar()"></app-botao>
  </div>
</div>
